import React from 'react';
import { Target, Compass } from 'lucide-react';
export function MissionVisionSection() {
  return <section id="nosotros" className="py-16 md:py-24 bg-[#1B2B5E] text-white" data-id="element-111">
      <div className="container mx-auto px-4 md:px-6" data-id="element-112">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-113">
          {/* Mission */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-12 rounded-2xl hover:bg-white/10 transition-colors duration-300" data-id="element-114">
            <div className="w-16 h-16 bg-[#F5A623] rounded-2xl flex items-center justify-center mb-8 transform -rotate-6" data-id="element-115">
              <Target size={32} className="text-[#1B2B5E]" data-id="element-116" />
            </div>
            <h2 className="text-3xl font-bold mb-6 text-white" data-id="element-117">
              Nuestra Misión
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-118">
              Brindar envíos puerta a puerta confiables, seguros y eficientes,
              acompañando a nuestros clientes con atención personalizada.
            </p>
          </div>

          {/* Vision */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-12 rounded-2xl hover:bg-white/10 transition-colors duration-300" data-id="element-119">
            <div className="w-16 h-16 bg-[#F5A623] rounded-2xl flex items-center justify-center mb-8 transform rotate-6" data-id="element-120">
              <Compass size={32} className="text-[#1B2B5E]" data-id="element-121" />
            </div>
            <h2 className="text-3xl font-bold mb-6 text-white" data-id="element-122">
              Nuestra Visión
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-123">
              Ser la empresa logística más confiable para la comunidad
              venezolana en Miami, reconocida por eficiencia y trato humano.
            </p>
          </div>
        </div>
      </div>
    </section>;
}